import { render } from "./OverlayLoader.vue?vue&type=template&id=a5c95b04"
import script from "./OverlayLoader.vue?vue&type=script&lang=js"
export * from "./OverlayLoader.vue?vue&type=script&lang=js"

import "./OverlayLoader.vue?vue&type=style&index=0&id=a5c95b04&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__